import React, { useEffect, useRef } from 'react';

export default function ScrollProgress({ progress }) {
  const barRef = useRef(null);
  const targetRef = useRef(progress);
  const currentRef = useRef(progress);

  useEffect(() => {
    targetRef.current = Math.max(0, Math.min(1, progress));
  }, [progress]);

  useEffect(() => {
    let raf;
    const ease = 0.14;

    const animate = () => {
      const target = targetRef.current;
      const next = currentRef.current + (target - currentRef.current) * ease;
      currentRef.current = Math.abs(target - next) < 0.0005 ? target : next;

      if (barRef.current) {
        barRef.current.style.transform = `scaleX(${currentRef.current})`;
      }

      raf = requestAnimationFrame(animate);
    };

    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-[2px] z-[60]">
      <div
        ref={barRef}
        className="h-full bg-white/60"
        style={{ transform: `scaleX(${Math.max(0, Math.min(1, progress))})`, transformOrigin: 'left center', willChange: 'transform' }}
      />
    </div>
  );
}
